'use client';

import {
  DEFAULT_VARIANTS_COMMENTS,
  DEFAULT_VARIANTS_TIMELINE,
} from './constants';
import { PanelBase, PanelIndicator } from './PanelBase';
import type { AnimatedIconProps, AnimatedPanelIndicatorProps } from './types';

export type AnimatedIconPanelAssetDetailsProps = AnimatedIconProps & {
  /**
   * if $isTimeline is `true`, the indicator will show a timeline panel as a horizontal line
   * @default `false`
   */
  $isHorizontal?: boolean;
};

/**
 * @description Animated icon showing the visible or selected states of the asset details panel
 */
export const AnimatedIconPanelAssetDetails = ({
  $isSelected,
  $isHorizontal,
  ...props
}: AnimatedIconPanelAssetDetailsProps) => (
  <PanelBase {...props}>
    {$isHorizontal ? (
      <PanelIndicatorTimeline $isSelected={$isSelected} />
    ) : (
      <PanelIndicatorComments $isSelected={$isSelected} />
    )}
  </PanelBase>
);

const PanelIndicatorComments = ({
  variants = DEFAULT_VARIANTS_COMMENTS,
  ...props
}: AnimatedPanelIndicatorProps) => (
  <PanelIndicator height="10" variants={variants} y="7" {...props} />
);

const PanelIndicatorTimeline = ({
  variants = DEFAULT_VARIANTS_TIMELINE,
  ...props
}: AnimatedPanelIndicatorProps) => (
  <PanelIndicator variants={variants} width="10" x="7" {...props} />
);
